/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */

import Heading from 'components/Heading/Heading'
import { Container } from 'components/layout/Grid/'
import constants from 'constants'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import styles from './Home.scss'
import Tile from './components/Tile'

class HomeView extends React.Component {
  static propTypes = {
    // beneficiaries: PropTypes.object.isRequired,  // everything under state.beneficiaries
    // openAddBeneficiaryForm: PropTypes.func,
    // getBeneficiaries: PropTypes.func,
  }

  static defaultProps = {

  }

  componentDidMount() {
    // this.props.getBeneficiaries()
  }

  // eslint-disable-next-line consistent-return
  renderHomePageLinks(links, userDetails) {
    if (links.Link.startsWith('http')) {
      return (
        <a href={links.Link}>
          <Tile
            description={links.Description}
            imageUrl={links.Image}
            title={links.Heading}
          />
        </a>
      )
    } else if (links.Heading === 'Admin center') {
      if (userDetails.IsAdmin) {
        return (
          <Link to={links.Link}>
            <Tile
              description={links.Description}
              imageUrl={links.Image}
              title={links.Heading}
            />
          </Link>
        )
      }
    } else {
      return (
        <Link to={links.Link}>
          <Tile
            description={links.Description}
            imageUrl={links.Image}
            title={links.Heading}
          />
        </Link>
      )
    }
  }

  render() {
    const currentUser = this.props.currentUser
    return (
      <div>
        <div className={styles.baseBlack}>
          <div className={styles.appsWrapper}>
            <div className={styles.epicHeaderWrapper}>
              <div className={styles.header}>Our Partnership<br />at a personal level</div>
              <div className={styles.headerDesc}>Through EPIC, you get a personalised view of everything that’s important to you as a Partner, enabling you to control your finances and personal information. With a click of a button, you can access your tax statements, elect your beneficiaries or map out your professional goals.</div>
            </div>
            <div className={styles.epicLogoWrapper}>
              <img alt="" className={styles.epicHeaderImg} src={`${process.env.PUBLIC_URL}/images/EpicHomeHeader.png`} />
            </div>
          </div>
        </div>
        <Container topPadding>
          <div className={styles.epicTilesWrapper}>
            <div>
              <Row>
                {constants.HomePageLinks.map((links, i) =>
                (<Col key={i} sm={4}>
                  {this.renderHomePageLinks(links, currentUser)}
                  {/* <Link to={links.Link}>
                    <Tile
                      description={links.Description}
                      imageUrl={links.Image}
                      title={links.Heading}
                    />
                  </Link> */}
                </Col>))}
              </Row>

            </div>
          </div>
        </Container>
        <div className={styles.getHelpWrapper}>
          <Heading size="large">Get a little help</Heading>
          <p className={styles.helpText}>Access the quick reference guides and FAQs on the Partner Hub</p>
          <a className={styles.linkButton} href="https://ausdeloitte.sharepoint.com/sites/DOL-c-AU-PartnerHub/EPIC_Help_Centre/Forms/AllItems.aspx?id=/sites/DOL-c-AU-PartnerHub/EPIC_Help_Centre/EPIC Quick Reference Guide.pdf&parent=/sites/DOL-c-AU-PartnerHub/EPIC_Help_Centre" rel="noopener noreferrer" target="_blank">
            Get Help
          </a>
        </div>
      </div>

    )
  }
}

export default HomeView



// WEBPACK FOOTER //
// ./src/views/Home/Home.js